import { useState } from "react";
import { api } from "../lib/api.js";
import { Field } from "./forms.jsx";

export default function Login({ onSignedIn, onExit }) {
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!password) return setErr("Bitte das Passwort eingeben.");
    setBusy(true);
    try {
      const data = await api.signIn(password);
      onSignedIn(data);
    } catch (ex) {
      setErr(ex.message);
      setPassword("");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wrap">
      <form className="gate" onSubmit={submit}>
        <h1>Verwaltung öffnen</h1>
        <p className="admin-sub" style={{ marginBottom: 22 }}>
          Das Passwort hat der Vorstand.
        </p>

        <Field label="Passwort" id="g-c">
          <input
            id="g-c"
            type="password"
            value={password}
            autoFocus
            autoComplete="current-password"
            onChange={(e) => {
              setPassword(e.target.value);
              setErr("");
            }}
          />
        </Field>

        <div className="acts">
          <button className="b" type="submit" disabled={busy}>
            {busy ? "Wird geprüft ..." : "Öffnen"}
          </button>
          <button className="b b-ghost" type="button" onClick={onExit}>
            Zurück zur Seite
          </button>
        </div>

        {err ? (
          <p className="form-error" role="alert">
            {err}
          </p>
        ) : null}
      </form>
    </div>
  );
}
